import { render } from "./index.vue?vue&type=template&id=ac4618fc&scoped=true"
import script from "./footer-button.js?vue&type=script&lang=js"
export * from "./footer-button.js?vue&type=script&lang=js"

import "./footer-button.scss?vue&type=style&index=0&id=ac4618fc&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\devin\\Desktop\\Web\\Portfolios\\Portolio\\vue-personal-portfolio\\portfolio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac4618fc"]])

export default __exports__